import { query } from "@/api"
import { Commit, Dispatch, ActionTree } from "vuex"
import { addVuexEntity } from ".."
import { Getters } from "../getters"
import ls from "local-storage"
const { toast } = require("vue3-toastify")

export interface User {
    displayName: string
    roles: string[]
    queriesUsed: number
    queriesLimit: number
}
export interface Guest {
    id: string
    queriesUsed: number
}

export interface UserState {
    user: User | null
    guest: Guest | null
    userLoading: Promise<any> | null
}

const apiCall = async () => {
    const res = await query("whoAmI", ["userId", "displayName", "email", "roles", "queriesUsed", "queriesLimit"])
    return res
}

const apiCallGuest = async () => {
    if (!(ls as any)("guestId")) {
        ls("guestId", ("" + Math.random()) + +new Date())
    }
    const guestId = (ls as any)("guestId")
    const res = await query("getCurrentGuest", ["guestId", "queriesUsed"], { guestId })
    return res
}

const module = {
    state() {
        const state = {
            user: null,
            guest: null,
            userLoading: null
        } as UserState
        return state
    },
    mutations: {
        SET_USER_LOADING(state: UserState, value: Promise<any>) {
            state.userLoading = value
        },
        SET_USER(state: UserState, value: User) {
            state.user = value
        },
        SET_GUEST(state: UserState, value: Guest) {
            state.guest = value
        }
    },
    actions: {
        async getUser({ commit, getters } : {commit: Commit, getters: Getters}) {
            try {
                console.log("state", { apiCall })
                if ((ls as any)("token") || getters.user) {
                    const promise = apiCall()
                    commit("SET_USER_LOADING", promise)
                    const res = await promise
                    commit("SET_USER", res)
                } else {
                    const promise = apiCallGuest()
                    commit("SET_USER_LOADING", promise)
                    const res = await promise
                    commit("SET_GUEST", res)
                }
            } catch (e) {
                toast("getUser" + " failed: " + e, { type: "error", position: "bottom-right", theme: "colored" })
                throw new Error("getUser" + " failed: " + e)
            } finally {
                commit("SET_USER_LOADING", null)
            }
        }
    }
}

export default module
